import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import LoginScreen from './pages/login';
import DealershipManagement from './pages/dealership-management';
import TechnicianAssignment from './pages/technician-assignment';
import OrderManagementDashboard from './pages/order-management-dashboard';
import TechnicianMobileView from './pages/technician-mobile-view';
import VinScanner from './pages/vin-scanner';
import EndeZeitScanner from './pages/ende-zeit-scanner';
import OrderDetailsPage from './pages/order-details';
import RevenueAnalyticsDashboard from './pages/revenue-analytics-dashboard';
import ServiceTypesManagement from './pages/service-types-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Default route redirects to login */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<LoginScreen />} />
        
        {/* Protected routes - require authentication */}
        {/* <Route path="/dealership-management" element={
          <ProtectedRoute>
            <DealershipManagement />
          </ProtectedRoute>
        } />
        <Route path="/technician-assignment" element={
          <ProtectedRoute>
            <TechnicianAssignment />
          </ProtectedRoute>
        } /> */}
        <Route path="/order-management-dashboard" element={
          <ProtectedRoute>
            <OrderManagementDashboard />
          </ProtectedRoute>
        } />
        {/* <Route path="/technician-mobile-view" element={
          <ProtectedRoute>
            <TechnicianMobileView />
          </ProtectedRoute>
        } /> */}
        <Route path="/vin-scanner" element={
          <ProtectedRoute>
            <VinScanner />
          </ProtectedRoute>
        } />
        <Route path="/ende-zeit-scanner" element={
          <ProtectedRoute>
            <EndeZeitScanner />
          </ProtectedRoute>
        } />
        {/* <Route path="/order-details" element={
          <ProtectedRoute>
            <OrderDetailsPage />
          </ProtectedRoute>
        } />
        <Route path="/revenue-analytics-dashboard" element={
          <ProtectedRoute>
            <RevenueAnalyticsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/service-types-management" element={
          <ProtectedRoute>
            <ServiceTypesManagement />
          </ProtectedRoute>
        } /> */}
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
